import { httpGet } from 'utils';
import { EstimatedManagementFeeResponse } from 'views/shared/types';

export const fetchEstimatedFeeAmounts = () => httpGet<EstimatedManagementFeeResponse>('portal/EstimateManagementFee');
